<ion-app>
    <ion-router-outlet></ion-router-outlet>
    <div *ngIf="(loading | async) && !hasRun" [ngClass]="{'die': hideLoad}" class="splash"></div>
    <div *ngIf="(loading | async) && hasRun" [ngClass]="{'die': hideLoad}" class="loading"></div>
</ion-app>
<script src="https://player.vimeo.com/api/player.js"></script>